export const theme = {
    token: {
      colorPrimary: "#25D366",
      colorBgBase: "#070A12",
      colorTextBase: "#EAF0FF",
      borderRadius: 16,
      fontSize: 16,
    },
  };
  